import { get, post, sess_get, sess_post } from "../utils/HttpRequests";
import * as actionTypes from "./actionTypes";

export const loginUser = (email, password) => (dispatch) => {
  return new Promise((resolve, reject) => {

    post("admin/console/admin-login", { username: email, password: password, portal: 'ADMIN_PORTAL' })
      .then((response) => {
        if (response.response && response.response.data && response.response.data.error) {
          reject(response.response.data.error.reason)
        }
        if (response.data !== undefined && response.data.success) {
          dispatch({
            type: actionTypes.LOGIN_SUCCESS,
            payload: response.data.response,
          });
          return resolve(response.data.response);
        }
      })
      .catch((err) => {
        if (!err.response) {
          dispatch({
            type: actionTypes.NETWORK_ERROR,
            payload: "Network error",
          });
        }
        if (err.response && err.response.data.error.reason) {
          dispatch({
            type: actionTypes.LOGIN_FAIL,
            payload: err.response.data.error.reason,
          });
        }
        return resolve(err);
      });
  });
};

export const setUserFromLocalStorage = (token) => (dispatch) => {
  dispatch({
    type: actionTypes.SET_USER,
    payload: token,
  });
};

export const logoutUser = (sessionToken) => (dispatch) => {
  return new Promise((resolve, reject) => {
    localStorage.removeItem("admin-panel-sessionToken");
    sess_post("admin/console/logout", sessionToken, { portal: actionTypes.ADMIN_PORTAL })
      .then((response) => {
        if (response.data !== undefined && response.data.success) {
          dispatch({
            type: actionTypes.LOGOUT,
          });
          resolve(response);
        }
      })
      .catch((err) => {
        console.log(err);
        reject(err);
      })
  })
};

export const AutoLogout = (err) => (dispatch) => {
  if (
    err.response &&
    err.response.data &&
    err.response.data.error &&
    err.response.data.error.code == 1004
  ) {
    localStorage.removeItem('admin-panel-sessionToken');

    dispatch({
      type: actionTypes.LOGOUT,
    });
    window.location.reload();
  }
};

export const sendOtp = (phone_number) => (dispatch) => {
  return new Promise((resolve, reject) => {
    post('admin/console/send-otp', { phone_number })
      .then((response) => {
        if (response.data !== undefined && response.data.success) {
          dispatch({
            type: actionTypes.SEND_OTP,
            payload: response.data.response,
          });
          return resolve(response);
        }
      })
      .catch((err) => {
        console.log(err.response);
        const error = 'Send otp error'
        if (err && err.response && err.response.data && err.response.data.error && err.response.data.error.reason) {
          error = err.response.data.error.reason;
        }
        dispatch({
          type: actionTypes.ERROR,
          payload: error
        });
        return reject(err);
      });
  });
};

export const verifyOtp = ({ otp, secret, phone_number }) => async (
  dispatch
) => {
  try {
    console.log('verifyOtp');
    const response = await post('admin/console/verify-otp', {
      otp,
      secret,
      phone_number,
    });
    dispatch({
      type: actionTypes.VERIFY_OTP,
      payload: response.data.response,
    });
  } catch (err) {
    const error = 'Verify otp error'
    if (err && err.response && err.response.data && err.response.data.error && err.response.data.error.reason) {
      error = err.response.data.error.reason;
    }
    dispatch({
      type: actionTypes.ERROR,
      payload: error
    });
  }
};

export const resetPassword = ({
  phone_number,
  confirm_password,
  new_password,
}) => async (dispatch) => {
  try {
    const response = await post('admin/console/forgot-password', {
      phone_number,
      confirm_password,
      new_password,
    });
    dispatch({
      type: actionTypes.RESET_PASSWORD,
      payload: response.data.response,
    });
  } catch (err) {
    const error = 'Reset Password error'
    if (err && err.response && err.response.data && err.response.data.error && err.response.data.error.reason) {
      error = err.response.data.error.reason;
    }
    dispatch({
      type: actionTypes.ERROR,
      payload: error
    });
  }
};

export const generateSecret2FA = (username) => (dispatch) => {
  return new Promise((resolve, reject) => {
    post("admin/console/generate-secret", { username })
      .then((response) => {
        if (response.data !== undefined && response.data.success) {
          dispatch({
            type: actionTypes.TWO_FA_CREATE,
            payload: response.data.response,
          });
          resolve(response);
        }
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.data && err.response.data.error) {
          dispatchError(dispatch, err.response.data.error.reason);
        }
        return reject(err);
      });
  });
};

export const verify2FAToken = (username, token) => (dispatch) => {
  return new Promise((resolve, reject) => {
    post("admin/console/verify-2fa-token", { username, token, portal: actionTypes.ADMIN_PORTAL })
      .then((response) => {
        if (response.data !== undefined && response.data.success) {
          localStorage.setItem(
            "admin-panel-sessionToken",
            response.data.response["x-metro-sessiontoken"]
          );
          dispatch({
            type: actionTypes.TWO_FA_VERIFY,
            payload: response.data.response,
          });
          return resolve(response);
        }
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.data && err.response.data.error) {
          dispatchError(dispatch, err.response.data.error.reason);
        }
        return reject(err);
      });
  });
};

export const validate2FAToken = (username, token) => (dispatch) => {
  return new Promise((resolve, reject) => {
    post("admin/console/validate-2fa-token", { username, token, portal: actionTypes.ADMIN_PORTAL })
      .then((response) => {
        if (response.data !== undefined && response.data.success) {
          localStorage.setItem(
            "admin-panel-sessionToken",
            response.data.response["x-metro-sessiontoken"]
          );
          console.log('sdfs', response.data.response);
          localStorage.setItem("admin-panel-userName", response.data.response.user.name);
          dispatch({
            type: actionTypes.LOGIN_SUCCESS,
            payload: response.data.response,
          });
          return resolve(response);
        }
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.data && err.response.data.error) {
          dispatchError(dispatch, err.response.data.error.reason);
        }
        return reject(err);
      });
  });
};

export const send2FAOtp = (username) => (dispatch) => {
  return new Promise((resolve, reject) => {
    post("admin/console/send-otp-2fa", { username })
      .then((response) => {
        if (response.data !== undefined && response.data.success) {
          dispatch({
            type: actionTypes.TWO_FA_SEND_OTP,
            payload: response.data.response,
          });
          return resolve(response);
        }
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.data && err.response.data.error) {
          dispatchError(dispatch, err.response.data.error.reason);
        }
        return reject(err);
      });
  });
}

export const verify2FAOtp = (username, otp) => (dispatch) => {
  return new Promise((resolve, reject) => {
    post("admin/console/verify-otp-2fa", { username, otp })
      .then((response) => {
        if (response.data !== undefined && response.data.success) {
          dispatch({
            type: actionTypes.TWO_FA_VERIFY_OTP,
            payload: response.data.response,
          });
          return resolve(response);
        }
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.data && err.response.data.error) {
          dispatchError(dispatch, err.response.data.error.reason);
        }
        return reject(err);
      });
  });

}

function dispatchError(dispatch, reason) {
  dispatch({
    type: actionTypes.FIELDS_ERROR,
    payload: reason,
  });
}

export const resetState = () => (dispatch) => {
  dispatch({
    type: actionTypes.LOGOUT,
  });
};

export const setError = (error) => (dispatch) => {
  dispatch({
    type: actionTypes.ERROR,
    payload: error
  });
};

